import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "as-players" }
const _hoisted_2 = { class: "as-line-up-colunm-item" }
const _hoisted_3 = { class: "as-line-up-item as-line-up-item-team as-line-up-item-home" }
const _hoisted_4 = { class: "as-match__team" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "as-match__team-name" }
const _hoisted_7 = { class: "as-player as-player-row" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "as-player-shirt-name" }
const _hoisted_11 = { class: "as-shirt-number" }
const _hoisted_12 = { class: "as-d-flex as-align-items-center as-gap-4" }
const _hoisted_13 = {
  key: 1,
  class: "as-time"
}
const _hoisted_14 = { class: "as-line-up-colunm-item" }
const _hoisted_15 = { class: "as-line-up-item as-line-up-item-team as-line-up-item-home" }
const _hoisted_16 = { class: "as-match__team" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "as-match__team-name" }
const _hoisted_19 = { class: "as-player as-player-row" }
const _hoisted_20 = ["href"]
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "as-player-shirt-name" }
const _hoisted_23 = { class: "as-shirt-number" }
const _hoisted_24 = { class: "as-d-flex as-align-items-center as-gap-4" }
const _hoisted_25 = {
  key: 1,
  class: "as-time"
}

import { computed } from "vue";
import type { ILineups, IMatch, IStartingPlayers } from "~src/interfaces";
import { formatRateColor, getIncidentIcon } from "~src/helpers";
import NoData from "~src/components/NoData.vue";
import { useMatchDetailStore } from "~src/stores/MatchDetailStore";

const __default__ = {};

interface IProps {
  lineups: ILineups;
  match: IMatch;
  startingPlayers: IStartingPlayers;
  isSubstituted: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Players',
  props: {
    lineups: {},
    match: {},
    startingPlayers: {},
    isSubstituted: { type: Boolean, default: false }
  },
  setup(__props: any) {

const matchDetailStore = useMatchDetailStore();



const screenWidth = computed(() => matchDetailStore.getScreenWidth);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["as-line-up-colunm", {
        'as-line-up-colunm-sm': screenWidth.value < 370,
      }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              class: "as-match__team-logo",
              src: 
                _ctx.getImgUrlBySport(
                  'team',
                  _ctx.lineups?.coach?.home ? _ctx.lineups.coach?.home?.team_id : _ctx.match.home_team_id
                )
              
            }, null, 8, _hoisted_5),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.lineups?.coach?.home ? _ctx.lineups.coach?.home?.name : _ctx.match.home_team.name), 1)
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.startingPlayers.home, (player, key) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            class: _normalizeClass(["as-line-up-item as-line-up-item-home", {
            'as-line-up-item-last':
              `${key}` === `${_ctx.startingPlayers.home.length - 1}`,
          }])
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", {
                href: _ctx.getLinkPlayerDetail(player),
                class: "as-player-name"
              }, [
                _createElementVNode("img", {
                  class: "as-player-logo",
                  src: _ctx.getImgUrlBySport('player', player.id)
                }, null, 8, _hoisted_9),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", null, _toDisplayString(player.name), 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(player.shirt_number ? player.shirt_number : "") + "-" + _toDisplayString(player.position), 1)
                ])
              ], 8, _hoisted_8),
              _createElementVNode("div", _hoisted_12, [
                (player.incidents.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(player.incidents, (incident, incidentKey) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: incidentKey,
                        class: "as-player-incident"
                      }, [
                        (_unref(getIncidentIcon)(player, incident, _ctx.isSubstituted))
                          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(getIncidentIcon)(player, incident, _ctx.isSubstituted)), { key: 0 }))
                          : _createCommentVNode("", true),
                        ([1, 3, 9].includes(incident.type))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(incident.time) + "'", 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  : _createCommentVNode("", true),
                (player.rating !== '0.0')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "as-player-rating",
                      style: _normalizeStyle({
                  background: _unref(formatRateColor)(parseFloat(player.rating)),
                })
                    }, _toDisplayString(Number(player.rating).toFixed(1)), 5))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 2))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("img", {
              class: "as-match__team-logo",
              src: 
                _ctx.getImgUrlBySport(
                  'team',
                  _ctx.lineups?.coach?.away ? _ctx.lineups.coach?.away?.team_id : _ctx.match.away_team_id
                )
              
            }, null, 8, _hoisted_17),
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.lineups?.coach?.away ? _ctx.lineups.coach?.away?.name : _ctx.match.away_team.name), 1)
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.startingPlayers.away, (player, key) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            class: _normalizeClass(["as-line-up-item as-line-up-item-away", {
            'as-line-up-item-last':
              `${key}` === `${_ctx.startingPlayers.away.length - 1}`,
          }])
          }, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("a", {
                href: _ctx.getLinkPlayerDetail(player),
                class: "as-player-name"
              }, [
                _createElementVNode("img", {
                  class: "as-player-logo",
                  src: _ctx.getImgUrlBySport('player', player.id)
                }, null, 8, _hoisted_21),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("span", null, _toDisplayString(player.name), 1),
                  _createElementVNode("span", _hoisted_23, _toDisplayString(player.shirt_number ? player.shirt_number : "") + "-" + _toDisplayString(player.position), 1)
                ])
              ], 8, _hoisted_20),
              _createElementVNode("div", _hoisted_24, [
                (player.incidents.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(player.incidents, (incident, incidentKey) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: incidentKey,
                        class: "as-player-incident"
                      }, [
                        (_unref(getIncidentIcon)(player, incident, _ctx.isSubstituted))
                          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(getIncidentIcon)(player, incident, _ctx.isSubstituted)), { key: 0 }))
                          : _createCommentVNode("", true),
                        ([1, 3, 9].includes(incident.type))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(incident.time) + "'", 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  : _createCommentVNode("", true),
                (player.rating !== '0.0')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "as-player-rating",
                      style: _normalizeStyle({
                  background: _unref(formatRateColor)(parseFloat(player.rating)),
                })
                    }, _toDisplayString(Number(player.rating).toFixed(1)), 5))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 2))
        }), 128))
      ])
    ], 2),
    (!_ctx.startingPlayers.home.length && !_ctx.startingPlayers.away.length)
      ? (_openBlock(), _createBlock(NoData, {
          key: 0,
          title: "Không có dữ liệu",
          modifyClass: "as-h-auto"
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})